import { render, staticRenderFns } from "./damage-assessment-form.vue?vue&type=template&id=38c48790&scoped=true"
import script from "./damage-assessment-form.vue?vue&type=script&lang=js"
export * from "./damage-assessment-form.vue?vue&type=script&lang=js"
import style0 from "./damage-assessment-form.vue?vue&type=style&index=0&id=38c48790&prod&scoped=true&lang=css"
import style1 from "./damage-assessment-form.vue?vue&type=style&index=1&id=38c48790&prod&lang=css"
import style2 from "./damage-assessment-form.vue?vue&type=style&index=2&id=38c48790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c48790",
  null
  
)

export default component.exports